const ratesTransformer = (rates) => {
  return {
    discounted: rates.discounted,
    // Always set discountedRate, even if there's no discount.
    // It makes price comparison between units much simpler.
    discountedRate: rates.discounted ? rates.discountedRate : rates.rate,
    rate: rates.rate,
    taxInclusive: rates.taxInclusive
  };
};
const unitTypeTransformer = (unitType, location) => {
  let deal = void 0;
  let rates;
  if (unitType.deals.length > 0) {
    const [firstDeal] = unitType.deals;
    deal = {
      _id: firstDeal._id,
      title: firstDeal.title,
      descriptions: firstDeal.descriptions,
      tags: firstDeal.tags,
      deleted: firstDeal.deleted,
      customFormat: firstDeal.customFormat,
      discountPlan: firstDeal.discountPlan,
      enable: firstDeal.enable,
      public: firstDeal.public,
      rates: firstDeal.rates,
      sLocationCode: firstDeal.sLocationCode,
      personas: firstDeal.personas
    };
    if (firstDeal.discountPlan) {
      deal.discountPlan = {
        _id: firstDeal.discountPlan._id,
        ConcessionID: firstDeal.discountPlan.ConcessionID,
        dcRoundTo: firstDeal.discountPlan.dcRoundTo,
        bRound: firstDeal.discountPlan.bRound,
        dcPCDiscount: firstDeal.discountPlan.dcPCDiscount,
        dcFixedDiscount: firstDeal.discountPlan.dcFixedDiscount,
        dcChgAmt: firstDeal.discountPlan.dcChgAmt,
        iAmtType: firstDeal.discountPlan.iAmtType,
        iPrePaidMonths: firstDeal.discountPlan.iPrePaidMonths,
        bPrepay: firstDeal.discountPlan.bPrepay,
        iExpirMonths: firstDeal.discountPlan.iExpirMonths,
        bNeverExpires: firstDeal.discountPlan.bNeverExpires,
        sPlanName: firstDeal.discountPlan.sPlanName,
        iInMonth: firstDeal.discountPlan.iInMonth
      };
    }
    rates = ratesTransformer(unitType.deals[0].rates);
  } else {
    rates = ratesTransformer(unitType.rates);
  }
  let totalAvailable = unitType.iTotalVacant;
  if (location?.rapidstor.includeReservedUnitsInOccupied) {
    totalAvailable -= unitType.iTotalReserved;
  }
  return {
    corpCode: unitType.sCorpCode,
    locationCode: unitType.sLocationCode,
    unitTypeId: unitType.UnitTypeID,
    typeName: unitType.sTypeName,
    deleted: unitType.deleted,
    stdRate: unitType.dcStdRate,
    stdWeeklyRate: unitType.dcStdWeeklyRate,
    area: unitType.dcArea,
    width: unitType.dcWidth,
    length: unitType.dcLength,
    floor: unitType.iFloor,
    inside: unitType.bInside,
    hasComputedAvailable: unitType.hasComputedAvailable,
    totalOccupied: unitType.iTotalOccupied,
    totalReserved: unitType.iTotalReserved,
    totalUnits: unitType.iTotalUnits,
    totalVacant: unitType.iTotalVacant,
    totalAvailable,
    firstAvailableUnitName: unitType.sUnitName_FirstAvailable,
    representativeUnitName: unitType.sUnitName_Representative,
    reservationFee: unitType.dcReservationFee,
    excludeFromInsurance: unitType.bExcludeFromInsurance,
    units: unitType.units,
    _id: unitType._id,
    deal,
    deals: unitType.deals,
    rates,
    unitToUse: unitType.unitToUse
  };
};
function determineFloor(unitType) {
  if (unitType.floor > 0) {
    return "upper";
  } else if (unitType.inside) {
    return "ground";
  } else {
    return "driveup";
  }
}
function distributeUnitsToGroups(unitTypes) {
  const groups = {
    ground: null,
    upper: null,
    driveup: null
  };
  for (const unitType of unitTypes) {
    const group = determineFloor(unitType);
    if (groups[group] === null) {
      groups[group] = unitType;
      continue;
    }
    const existingUnitType = groups[group];
    if (existingUnitType.totalVacant === 0 && unitType.totalVacant > 0 || unitType.totalVacant > 0 && unitType.rates.rate < existingUnitType.rates.rate || unitType.totalVacant === 0 && existingUnitType.totalVacant === 0 && unitType.rates.rate < existingUnitType.rates.rate) {
      groups[group] = unitType;
    }
  }
  return groups;
}
export {
  determineFloor,
  distributeUnitsToGroups,
  ratesTransformer,
  unitTypeTransformer
};
//# sourceMappingURL=UnitType.mjs.map